import { Currency } from '@pancakeswap/sdk'
import { Text, Heading } from '@pancakeswap/uikit'
import { LightGreyCard, LightCardProps } from 'components/Card'
import EBox from 'components/EBox'
import { paddingBottom, paddingRight } from 'styled-system'

interface RangePriceSectionProps extends LightCardProps {
  title: string
  currency0: Currency
  currency1: Currency
  price: string
}

export const RangePriceSection = ({ title, currency0, currency1, price, ...props }: RangePriceSectionProps) => {
  return (
    <EBox style={{ width: '100%', paddingLeft: '15px', paddingTop: '10px', paddingBottom: '10px' }} {...props}>
      <Text fontSize="12px" color="secondary" bold textTransform="uppercase" mb="4px">
        {title}
      </Text>
      <Text fontSize="16px">{price}</Text>
      <Text fontSize="16px" color="textSubtle">
        {currency0?.symbol} per {currency1?.symbol}
      </Text>
    </EBox>
  )
}
